import { BoldText } from '@elements/Common';
import { describeRequestedShipping } from '@features/order-details';
import type { OrderRequestedShipping } from '@skupreme/api-contracts/core';

export type RequestedShippingProps = {
  requested: OrderRequestedShipping | null | undefined;
};

/**
 * The service level the marketplace asked for, which the fulfillment forms head
 * with so the operator can see what they are about to buy against.
 */
export function RequestedShipping({ requested }: RequestedShippingProps) {
  const { value, detail, pinned } = describeRequestedShipping(requested);

  if (!value) return <div>Requested method not provided by marketplace</div>;

  return (
    <div>
      Requested <BoldText>“{value}”</BoldText>
      {detail ? ` (${detail})` : ''}
      {pinned ? ' — carrier pinned by marketplace' : ''}
    </div>
  );
}
